import React from 'react';

import './app-layout.scss';

import { Navigation } from '../navigation/Navigation';

export const AppLayout = ({ title, children }) => {
  return (
    <div className="app-layout">
      <Navigation />
      <div className="app-layout__content">
        <span className="app-layout__title">{title}</span>
        <div>{children}</div>
      </div>
    </div>
  );
};
